import {Component, OnInit} from '@angular/core';
import {UserService} from "../services/user.service";
import {Router} from "@angular/router";
import {AdminService} from "../services/admin.service";

@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {
    permission: String;
    customer: Boolean;
    constructor(private userService: UserService,
                private router: Router,
                private adminService: AdminService) {
    }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.adminService.groupupdate.subscribe(permData => {
                localStorage.setItem('permission', permData.permission);
                this.permission=permData.permission
            })
            this.permission = this.adminService.getPermission();
            this.customer = false;
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/index/index.component.ts